<template>
    <div class="tab-pane fade show active position-relative" id="activity">
        <div v-bind:class="{ open: uiStates.activeModal == 'relationAttributes' , 'is-loading': uiStates.showLoading  }" class="slider-modal">
            <transition name="vue-table-loader">
                <div class="vue-details-loader alt" v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
            </transition>
            <transition name="fade">
                <div class="container"  v-if="uiStates.activeModal == 'relationAttributes'">
                    <a v-on:click="closeAttributesModal()"  class="close-section">&times;</a>
                    <div class="slider-modal-copy">
                        <div class="attributes-container">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3>{{visibleModalFields.name}}</h3>
                                </div>
                            </div>
                            <input-loader :fields="visibleModalFields.attributes"></input-loader>
                            <div class="row">
                                <div class="col-md-12 text-right">
                                    <button type="button" class="btn btn-secondary" @click="closeAttributesModal()">Cancel</button>
                                    <button type="button" class="btn btn-primary" @click="saveRelationAttributes(visibleModalFields)">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>


        <transition name="vue-table-loader">
            <div class="vue-details-loader alt" v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
        </transition>
        <div class="product-form-tab">
            <div class="row">
                <div class="col-md-6">
                    <h3 class="pt-2 mb-2">Product Relations</h3>
                    <p class="text-muted text-xs max-w-para">
                        Configure and edit relations between different products. This requires the creation of
                        product relations, which can be done <a href="/product-relation-types">here</a>. To learn more
                        about relations, <a href="https://jasperpim.atlassian.net/wiki/spaces/JPKB/pages/57803093/Understanding+Product+Relations">
                        click here</a>.
                    </p>
                </div>
                <div class="col-md-6 text-right">
                    <a v-on:click.prevent="uiStates.addProductRelation = true" href="#" v-if="!uiStates.addProductRelation && $parent.$parent.permissionAllowed('manage_products') && $parent.$parent.permissionAllowed('product_relations')" class="btn btn-primary">Add Relation</a>
                </div>
            </div>
            <div v-if="uiStates.addProductRelation" id="adjust_relationship" class="pl-4 pr-4 mb-3">
                <!-- if there are no relations provide a link to the create relation type -->
                <select-item-from-api-provided-list
                    api="pimapi/product-related-types"
                    :columns="['name']"
                    list-label="1) Select Relation Type"
                    @selection="handleRelationSelected"
                >
                </select-item-from-api-provided-list>

                <select-item-from-api-provided-list
                    class="pt-2"
                    api="pimapi/products"
                    :columns="['name', 'sku']"
                    list-label="2) Select Product"
                    @selection="handleProductSelected"
                >
                </select-item-from-api-provided-list>

                <div class="apply-new-relationship">
                    <a v-on:click.prevent="postRelation()" :class="{disabled: !selectionsComplete}" href="#" class="btn btn-primary mr-1">Add Relation</a>
                    <a v-on:click.prevent="uiStates.addProductRelation = false" href="#" class="btn btn-secondary">Close</a>
                </div>
            </div>
            <div v-for="(relation, index) in relations" class="table_container" :key="index">
                <div class="row">
                    <div class="col-md-12 clearfix">
                        <h3 class="text-sm" style="color: #576670;">{{relation.name}}</h3>
                    </div>
                </div>
                <div class="dataTables_wrapper container-fluid dt-bootstrap4">
                   <table class="table table-middle table-minimal">
                           <thead>
                               <tr>
                                    <th>Name</th>
                                    <th style=""></th>
                               </tr>
                           </thead>
                           <tbody v-for="product in relation.products" :key="product.id">
                               <tr class="scan-thumbnail">
                                    <td>
                                        <div :class="{'has-thumb': product.thumbnail !== null}" class="position-relative">
                                            <div class="product-details-thumbnail bg-pos-center" v-if="product.thumbnail" :style="{ backgroundImage: 'url(' + product.thumbnail + ')' }"></div>
                                            <a class="d-block text-xs" :href="'/products/'+product.id +'/edit'" >
                                                {{product.name}}
                                            </a>
                                            <small v-if="product.sku">
                                                SKU: {{product.sku}}
                                            </small>
                                            <small v-else>
                                                SKU: N/A
                                            </small>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="actions-relation-container clearfix" v-if="$parent.$parent.permissionAllowed('manage_products') && $parent.$parent.permissionAllowed('product_relations')">
                                            <div class="action-container clearfix">
                                                <transition v-bind:name="confirmDelete.transitionValue">
                                                    <div v-if="showConfirmDeleteButton(confirmDelete, product)" class="btn-group btn-confirm-delete">
                                                        <a class="btn btn-danger"  v-on:click.prevent="deleteRelation(product.id, product.type_id)" href=""><span>Confirm</span>   </a>
                                                        <div class="btn btn-outline-danger" @click="cancelDeletion()"><i class="fa fa-times" aria-hidden="true"></i></div>
                                                    </div>

                                                    <button class="btn btn-danger btn-start-confirmation" @click="confirmDeletion(product)" v-if="showDeleteButton(confirmDelete, product)"><span>Delete</span>    </button>
                                                </transition>
                                            </div>
                                            <a href="#" v-if="product.attributes.length > 0" v-on:click.prevent="loadAttributesModal(product)" class="btn btn-outline-primary">
                                                <span>Attributes</span>
                                            </a>
                                        </div>
                                    </td>
                               </tr>
                           </tbody>
                       </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var base_url = window.location.protocol + "//" + window.location.host;
import axios from "axios";
import SelectItemFromApiProvidedList from "../generic/select-item-from-api-provided-list.vue";
import BasePagination from "../tables/base-pagination.vue";
import BasePaginationInfo from "../tables/base-pagination-info.vue";
import InputLoader from "../form/form-loader.vue";

export default {
    name: "product-relations-list",
    components: {
        "base-pagination": BasePagination,
        "base-pagination-info": BasePaginationInfo,
        "input-loader": InputLoader,
        "select-item-from-api-provided-list": SelectItemFromApiProvidedList
    },
    data() {
        return {
            uiStates: {
                showLoading: true,
                addProductRelation: false,
                activeModal: ""
            },
            confirmDelete: {
                relationId: null,
                typeId: null,
                transitionValue: "slide",
                isActive: false
            },
            relations: [],
            productRelationListing: {
                products: [],
                relationTypes: [],
                selected: {
                    type: null,
                    product: null
                }
            },
            visibleModalFields: {
                name: "",
                attributes: []
            },
            selectedRelationshipType: {},
            selectedProduct: {}
        };
    },
    mounted() {
        this.loadAllRelations();
    },
    computed: {
        selectionsComplete() {
            return (
                this.selectedRelationshipType.hasOwnProperty("id") &&
                this.selectedProduct.hasOwnProperty("id")
            );
        }
    },
    methods: {
        handleRelationSelected(item) {
            this.selectedRelationshipType = item;
        },
        handleProductSelected(item) {
            this.selectedProduct = item;
        },
        reloadSidebarRelations() {
            this.$parent.$parent.$children.forEach(function(el, i) {
                if (el.$options._componentTag === "product-sidebar") {
                    el.loadProductRelations();
                }
            });
        },
        loadAttributesModal(productData) {
            if (this.uiStates.activeModal === "relationAttributes") {
                this.closeAttributesModal();
            } else {
                this.visibleModalFields = productData;
                this.uiStates.activeModal = "relationAttributes";
            }
        },
        closeAttributesModal() {
            this.visibleModalFields = {
                name: "",
                attributes: []
            };
            this.uiStates.activeModal = "";
        },
        loadAllRelations() {
            axios
                .get(
                    base_url +
                        "/pimapi/products/" +
                        this.$parent.$parent.product.info.id +
                        "/relationswithattributes/",
                    {}
                )
                .then(
                    function(response) {
                        this.relations = response.data.payload.relations;
                        this.uiStates.showLoading = false;
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        // this.alert.status = "alert-danger";
                        this.uiStates.showLoading = false;
                        // this.$parent.$parent.alert.status = "alert-danger";
                        // this.$parent.$parent.alert.message = 'An error has occurred with relations'
                    }.bind(this)
                );
        },
        postRelation: function(criteria) {
            this.uiStates.showLoading = true;
            axios
                .post(
                    base_url +
                        "/pimapi/products/" +
                        this.$parent.$parent.product.info.id +
                        "/relation/" +
                        this.selectedProduct.id +
                        "/type/" +
                        this.selectedRelationshipType.id,
                    {
                        // 'criteria': criteria,
                    }
                )
                .then(
                    function(response) {
                        this.loadAllRelations();
                        this.uiStates.showLoading = false;
                        this.uiStates.addProductRelation = false;
                        console.log(response.data);
                        if (response.data.status) {
                            this.$parent.$parent.alert.status = "alert-success";
                            this.$parent.$parent.alert.message =
                                "Relation successfully added";
                        } else {
                            this.$parent.$parent.alert.status = "alert-danger";
                            this.$parent.$parent.alert.message =
                                response.data.message;
                        }
                        this.reloadSidebarRelations();
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.uiStates.showLoading = false;
                        this.uiStates.addProductRelation = false;
                        this.$parent.$parent.alert.status = "alert-danger";
                        this.$parent.$parent.alert.message =
                            error.response.data.message;
                    }.bind(this)
                );
        },
        deleteRelation: function(relationId, typeId) {
            this.uiStates.showLoading = true;
            axios
                .delete(
                    base_url +
                        "/pimapi/products/" +
                        this.$parent.$parent.product.info.id +
                        "/relation/" +
                        relationId +
                        "/type/" +
                        typeId,
                    {
                        // 'criteria': criteria,
                    }
                )
                .then(
                    function(response) {
                        this.loadAllRelations();
                        this.uiStates.showLoading = false;
                        this.$parent.$parent.alert.status = "alert-success";
                        this.$parent.$parent.alert.message =
                            "Relation successfully deleted";
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.uiStates.showLoading = false;
                        this.$parent.$parent.alert.status = "alert-danger";
                        this.$parent.$parent.alert.message =
                            error.response.data.message;
                    }.bind(this)
                );
        },
        saveRelationAttributes(relationAttributes) {
            this.uiStates.showLoading = true;
            axios
                .post(
                    base_url +
                        "/pimapi/products/" +
                        this.$parent.$parent.product.info.id +
                        "/relationattributesave",
                    {
                        productRelationGrouping: relationAttributes
                    }
                )
                .then(
                    function(response) {
                        this.loadAllRelations();
                        this.$parent.$parent.alert.status = "alert-success";
                        this.$parent.$parent.alert.message =
                            "Product Relations successfully saved.";
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.uiStates.showLoading = false;
                        this.$parent.$parent.alert.status = "alert-danger";
                        this.$parent.$parent.alert.message =
                            error.response.data.message;
                    }.bind(this)
                );
        },
        showDeleteButton(confirmDelete, product) {
            if (!this.$parent.$parent.permissionAllowed('product_relations')) {
                return false;
            }
            return !(
                confirmDelete.relationId == product.id &&
                confirmDelete.typeId == product.type_id
            );
        },
        showConfirmDeleteButton(confirmDelete, product) {
            return (
                confirmDelete.relationId == product.id &&
                confirmDelete.typeId == product.type_id
            );
        },
        confirmDeletion(product) {
            if (this.confirmDelete.isActive == true) {
                this.cancelDeletion();
            } else {
                this.confirmDelete.isActive = true;
                this.confirmDelete.relationId = product.id;
                this.confirmDelete.typeId = product.type_id;
                this.confirmDelete.transitionValue = "slide-reverse";
            }
        },
        cancelDeletion() {
            this.confirmDelete.isActive = false;
            this.confirmDelete.relationId = null;
            this.confirmDelete.typeId = null;
            this.confirmDelete.transitionValue = "slide";
        }
    }
};
</script>

<style lang="scss">
.channel-status-column {
    width: 160px;
}

.list-label {
    margin: 10px 0;
    font-size: 17px;
}
</style>
<style lang="scss" scoped>
.apply-new-relationship {
    display: flex;
    justify-content: flex-end;
}

.product-details-thumbnail {
    position: absolute;
    top: -5px;
    left: 0;
    width: 45px !important;
    height: 45px !important;
}
.has-thumb {
    padding-left: 55px;
}
.table_container {
    margin-bottom: 40px;
}
.table tbody + tbody {
    border-top: 0px;
}
.btn-danger {
    padding: 10px 15px;
    &:hover,
    &:active,
    &:focus {
        color: white !important;
    }
}
.channel-tool-menu {
    display: inline;
    .btn {
        margin-top: -1px;
        width: 26px;
        height: 26px;
        padding: 0 0;
        border-color: #adadad;
        color: #686868;
    }
}
.table-minimal {
    margin-bottom: 0px !important;
    .btn {
        margin-top: 5px;
        margin-bottom: 5px;
        margin-right: 1px;
        padding: 9px 8px 8px 8px;
        font-size: 10px;
        font-weight: 500;
        line-height: 7px;
        height: 25px;
    }
}
.product-tool-menu {
    display: inline;
}
.channel-action-container {
    text-align: right;
}
.activities-table {
    min-height: 680px;
}
.channel-logo {
    width: 35px;
}
.badge-checkbox {
    text-transform: capitalize;
    border-color: #adadad;
    background-color: #fff;
    color: #686868;
    margin-top: 5px;
    width: 73px;
    .checkmark {
        border-color: #adadad;
        &:after {
            color: #3cab9f;
        }
    }
    &.badge-checkbox-checked {
        color: white;
        background-color: #3cab9f;
        border-color: #3cab9f;
        .checkmark {
            border-color: white;
        }
    }
}
.messaging {
    color: #566670;
    position: absolute;
    bottom: 2px;
    right: 5px;
    font-size: 9px;
}

.btn-confirm-delete {
    .btn {
        padding: 8px 8px 9px 8px;
        &:last-child {
            z-index: 10;
            // border-left:1px solid #ff9a9a;
        }
    }
}
.actions-relation-container {
    .action-container {
        margin-left: 5px;
    }
    .btn,
    .action-container {
        float: right;
    }
}
.btn-outline-danger {
    border-color: #ab5755;
    color: #ab5755;
}
.btn-outline-primary {
    padding: 8px 8px 8px 8px !important;
    width: 75px;
}
.action-container {
    position: relative;
    overflow: hidden;
    height: 25px;
    width: 79px;
    background-color: #ab5755;
    border-radius: 2px;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-right: 1px;
    .btn {
        margin-top: 0px;
        margin-bottom: 0px;
        margin-right: 0px;
        padding: 8px 8px 8px 8px;
    }
    .btn-start-confirmation {
        width: 100%;
    }
    .btn-confirm-delete,
    .btn-start-confirmation {
        position: absolute;
        top: 0;
    }
}
.slide-reverse-leave-active,
.slide-reverse-enter-active,
.slide-leave-active,
.slide-enter-active {
    transition: 0.4s;
}
.slide-enter {
    transform: translate(-100%, 0);
    span {
        transition: opacity 0.4s;
        opacity: 1;
    }
}
.slide-leave-to {
    span {
        transition: opacity 0.4s;
        opacity: 0;
    }
    transform: translate(100%, 0);
}

.slide-reverse-enter {
    transform: translate(100%, 0);
    span {
        transition: opacity 0.4s;
        opacity: 1;
    }
}
.slide-reverse-leave-to {
    span {
        transition: opacity 0.4s;
        opacity: 0;
    }
    transform: translate(-100%, 0);
}
</style>
